import React, { createContext, useContext, useEffect, useState } from "react";
import { safeJsonArrayGet, safeSet } from "@/lib/storage";

const FavoritesContext = createContext();

const readFavorites = () => {
  const storage = typeof window !== "undefined" ? window.localStorage : null;
  return safeJsonArrayGet(storage, "tw_favs", []).filter((id) => typeof id === "string" || typeof id === "number");
};

export const FavoritesProvider = ({ children }) => {
  const [ids, setIds] = useState(readFavorites);

  useEffect(() => {
    const storage = typeof window !== "undefined" ? window.localStorage : null;
    safeSet(storage, "tw_favs", JSON.stringify(Array.isArray(ids) ? ids : []));
  }, [ids]);

  const toggle = (id) => setIds((cur) => {
    const current = Array.isArray(cur) ? cur : [];
    return current.includes(id) ? current.filter((x) => x !== id) : [...current, id];
  });
  const has = (id) => (Array.isArray(ids) ? ids : []).includes(id);
  const clear = () => setIds([]);

  return (
    <FavoritesContext.Provider value={{ ids: Array.isArray(ids) ? ids : [], toggle, has, clear }}>
      {children}
    </FavoritesContext.Provider>
  );
};

export const useFavorites = () => useContext(FavoritesContext);
